import {PIXI} from '@colonist/pixi'
import {MovingSpriteView} from '../../ui_canvas_engine/MovingSpriteView'
import {TileCornerBuildingType} from '@colonist/game-states'
import {TileCorner} from '@colonist/game-mechanic-validators'

export class UIGameMapCornerView extends MovingSpriteView {
    corner: TileCorner
    buildingType: TileCornerBuildingType | undefined

    constructor(corner: TileCorner, x: number, y: number, w: number, h: number, layer: number, texture: PIXI.Texture, container: PIXI.Container) {
        super(x, y, w, h, container, texture)
        this.zIndex = layer
        this.corner = corner
        this.buildingType = corner.buildingType
    }
}
